import * as globals from '@wandb/common/css/globals.styles';
import React, {ReactNode, useState} from 'react';
import styled from 'styled-components';

const NavTabsContainer = styled.div`
  width: 100%;
  display: flex;
  gap: 40px;
  border-bottom: 2px solid ${globals.GRAY_300};

  font-size: 16px;
  font-weight: 600;
  line-height: 32px;
  color: ${globals.GRAY_800};
`;

const NavTabContainer = styled.div<{selected: boolean}>`
  // negative margin to overlap borders
  margin-bottom: -2px;
  ${({selected}) => selected && `border-bottom: 2px solid ${globals.TEAL};`}
  cursor: pointer;
`;

type NavTab = {
  Trigger: () => ReactNode;
  Content: () => ReactNode;
  disabled?: boolean;
  isHidden?: boolean;
};

export const NavTabs = ({
  defaultTab = 0,
  Tabs,
}: {
  defaultTab?: number;
  Tabs: NavTab[];
}) => {
  const [selectedTab, setSelectedTab] = useState<number>(
    defaultTab < Tabs.length ? defaultTab : 0
  );

  return (
    <>
      <NavTabsContainer>
        {Tabs.map(
          (tab: NavTab, idx: number) =>
            !tab.isHidden && (
              <NavTabContainer
                key={`navtab-trigger-${idx}`}
                onClick={() => !tab.disabled && setSelectedTab(idx)}
                selected={idx === selectedTab}>
                {tab.Trigger()}
              </NavTabContainer>
            )
        )}
      </NavTabsContainer>
      {Tabs[selectedTab].Content()}
    </>
  );
};
